import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/door/device/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/door/device/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/door/device/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/door/device/submit', params, options);

export const update = (params, options) => request.post('/api/door/device/submit', params, options);

//房产懒加载
export const getTreeList = () => {
  return request({
    url: '/api/door/device/getTreeList',
    method: 'get',
  });
};
//在设备授权功能中，parentId实际承接的参数为小区id 即CommunityId
export const getBasePropertyTree = (communityId) => {
  return request({
    url: '/api/base/property/getBasePropertyTree',
    method: 'get',
    params: {
      communityId,
    },
  });
};

export const auth = (params, options) => request.post('/api/door/deviceauth/auth', params, options);

export const getAuthInfo = (params, options) =>
  request.get('/api/door/deviceauth/getByDeviceIdOrAreaId', Object.assign({}, options, { params }));
